import { useEffect } from 'react';
import useApi from './useApi';
import { useEventTypeStore } from '../context/EventTypeContext';
import { EventTypeDataBM } from '../types/BusinessModel/EventTypeDataBM';
import { EventTypeData } from '../types/ViewModel/EventTypeData';
import { EventType } from '../types/ViewModel/EventType';
import EventTypeDataFactory from '../factory/EventTypeDataFactory';
import useApiEndpoints from '../context/useApiEndpoints';
import { buildQueryParams } from './endpoints/queryParamsHelper';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';

const GetEventTypeDataComponent = () => {
    const { apiEndpoints } = useApiEndpoints();
    const { processApiEndpointError } = apiEndpointUtils();
    const { state, getApiData } = useApi();
    const { setEventTypeDataPort, setEventTypeData, setEventTypeDataSea, setEventTypeArray } = useEventTypeStore();

    const getEventTypeData = (imoNumber: number) => {
        getApiData({
            endpoint: apiEndpoints['getEventTypeData'].url,
            queryParam: buildQueryParams({ imoNumber }),
        });
    };
    const { newEventTypeDataContext, newEventTypeData } = EventTypeDataFactory();

    useEffect(() => {
        if (state.status === 'success') {
            const evTypeDataBM = state.result as unknown as EventTypeDataBM;
            const evTypeDataSea: EventTypeData = newEventTypeDataContext(evTypeDataBM, 1);
            const evTypeDataPort: EventTypeData = newEventTypeDataContext(evTypeDataBM, 2);
            let evTypeArray: EventType[] = [];
            if (evTypeDataSea) {
                const evTypeGrSeaArray = evTypeDataSea.eventTypeLevelArray.flatMap((o) => o.eventTypeGroupArray);
                evTypeArray = evTypeGrSeaArray.flatMap((o) => o.eventTypeArray);
                setEventTypeDataSea(evTypeDataSea);
            }
            if (evTypeDataPort) {
                const evTypeGrPortArray = evTypeDataPort.eventTypeLevelArray.flatMap((o) => o.eventTypeGroupArray);
                const evTypePortArray = evTypeGrPortArray.flatMap((o) => o.eventTypeArray);
                evTypeArray = evTypeArray.concat(evTypePortArray);
                setEventTypeDataPort(evTypeDataPort);
            }
            setEventTypeArray(evTypeArray);
            setEventTypeData(newEventTypeData(evTypeDataBM));
        } else {
            processApiEndpointError(state);
        }
    }, [state]);

    return { state, getEventTypeData };
};

export default GetEventTypeDataComponent;
